import React from 'react';

import { Typography } from '@mui/material';

import { StlPopup } from 'features/common/StlPopup/StlPopup';
import { stl_error_color } from 'theme/cemTheme';

import FontAwesomeIcon from './FontAwesomeIcon';

interface ConfirmDeletePopupProps {
  isOpen: boolean;
  name?: string;
  setIsOpen: (val: boolean) => void;
  onApply: () => void;
  objectType: string;
  customMessage?: string;
}

export function ConfirmDeletePopup({
  isOpen,
  setIsOpen,
  name,
  onApply,
  objectType,
  customMessage,
}: ConfirmDeletePopupProps) {
  return (
    <StlPopup
      sx={{ width: '360px' }}
      color="errorStl"
      btnTxt="Delete"
      showCloseBtn={false}
      title={
        <div>
          <FontAwesomeIcon
            type="sharp-solid"
            name="triangle-exclamation"
            sx={{ marginRight: '2px', color: stl_error_color }}
          />
          <span>Delete {name}</span>
        </div>
      }
      isAlert
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      onApply={onApply}
    >
      {customMessage ? (
        <Typography variant="body2">{customMessage}</Typography>
      ) : (
        <Typography variant="body2">
          This action will permanently remove the {objectType} from all modules.
          Do you want to proceed?
        </Typography>
      )}
    </StlPopup>
  );
}
